import React from 'react';
import { Button } from 'react-admin';
import AddIcon from '@material-ui/icons/Add';

interface Props {
  onClick: () => void;
  variant?: 'create' | 'add';
  label?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
}

const CreateButton = (props: Props) => {
  const { onClick, variant = 'create', label, disabled, icon } = props;

  return (
    <Button label={label || `ra.action.${variant}`} onClick={onClick} disabled={disabled}>
      {icon ? icon : <AddIcon />}
    </Button>
  );
};

export default CreateButton;
